module.exports = __webpack_public_path__ + "static/media/homeitem5.3b38967b.png";